import { Link, useParams } from 'react-router-dom';

export function NotFound() {
  const { leagueId } = useParams();

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--ledger-bg)' }}>
      <div className="text-center">
        <h1 className="text-6xl font-bold mb-4" style={{ color: 'var(--ledger-ink)' }}>404</h1>
        <p className="text-xl mb-2" style={{ color: 'var(--ledger-muted)' }}>
          {leagueId ? `League "${leagueId}" not found` : 'Page not found'}
        </p>
        <p className="text-sm mb-6" style={{ color: 'var(--ledger-faint)' }}>
          The league may not exist or hasn't been initialized yet.
        </p>
        <Link
          to="/"
          className="ledger-btn"
          style={{ background: 'var(--ledger-ink)', borderColor: 'var(--ledger-ink)', color: 'var(--ledger-panel)' }}
        >
          Go to Home
        </Link>
      </div>
    </div>
  );
}

export default NotFound;
